// extracted by mini-css-extract-plugin
export default {"container":"styles_container__arLIU","contentWrapper":"styles_contentWrapper__N+RYL"};